import {
  TopicModelAsEditor,
  TopicElementModelAsEditor
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { last, get, findIndex } from 'lodash'
import { apolloClientPrivate } from '../../graphql/apolloClient'
import {
  DragUpMutation,
  DragUpMutationVariables,
  DragUpDocument,
  DragDownMutation,
  DragDownMutationVariables,
  DragDownDocument,
  SwapElementsMutation,
  SwapElementsMutationVariables,
  SwapElementsDocument,
  RemoveElementMutation,
  RemoveElementMutationVariables,
  RemoveElementDocument
} from './TopicElementsManager.codegen'

export const canMoveUp = (
  topic: TopicModelAsEditor,
  element: TopicElementModelAsEditor
) => {
  const elements: TopicElementModelAsEditor[] = get(
    topic,
    'draftVersion.elements'
  )
  if (elements.length < 2) {
    return false
  }
  const [firstElement] = elements

  return element.id !== firstElement.id
}

export const canMoveDown = (
  topic: TopicModelAsEditor,
  element: TopicElementModelAsEditor
) => {
  const elements: TopicElementModelAsEditor[] = get(
    topic,
    'draftVersion.elements'
  )
  if (elements.length < 2) {
    return false
  }
  const lastElement = last(elements) as TopicElementModelAsEditor
  return element.id !== lastElement.id
}

export const onDragUp = async (
  topic: TopicModelAsEditor,
  element: TopicElementModelAsEditor,
  toOrder: number
) => {
  await apolloClientPrivate.mutate<DragUpMutation, DragUpMutationVariables>({
    mutation: DragUpDocument,
    variables: {
      topicId: topic.id,
      elementId: element.id,
      reorderInput: {
        from: element.order,
        to: toOrder
      }
    }
  })
}

export const onDragDown = async (
  topic: TopicModelAsEditor,
  element: TopicElementModelAsEditor,
  toOrder: number
) => {
  await apolloClientPrivate.mutate<DragDownMutation, DragDownMutationVariables>(
    {
      mutation: DragDownDocument,
      variables: {
        topicId: topic.id,
        elementId: element.id,
        reorderInput: {
          from: element.order,
          to: toOrder
        }
      }
    }
  )
}

export const onMoveUp = async (
  topic: TopicModelAsEditor,
  element: TopicElementModelAsEditor
) => {
  const elements: TopicElementModelAsEditor[] = get(
    topic,
    'draftVersion.elements'
  )
  const currentElIndex = findIndex(elements, (e) => e.id === element.id)

  if (!canMoveUp(topic, element)) return

  const prevElement = elements[currentElIndex - 1]

  await apolloClientPrivate.mutate<
    SwapElementsMutation,
    SwapElementsMutationVariables
  >({
    mutation: SwapElementsDocument,
    variables: {
      topicId: topic.id,
      elementId: element.id,
      order: prevElement.order
    }
  })
}

export const onMoveDown = async (
  topic: TopicModelAsEditor,
  element: TopicElementModelAsEditor
) => {
  const elements: TopicElementModelAsEditor[] = get(
    topic,
    'draftVersion.elements'
  )
  const currentElIndex = findIndex(elements, (e) => e.id === element.id)

  if (!canMoveDown) return

  const nextElement = elements[currentElIndex + 1]

  await apolloClientPrivate.mutate<
    SwapElementsMutation,
    SwapElementsMutationVariables
  >({
    mutation: SwapElementsDocument,
    variables: {
      topicId: topic.id,
      elementId: element.id,
      order: nextElement.order
    }
  })
}

export const onRemove = async (
  topic: TopicModelAsEditor,
  element: TopicElementModelAsEditor
) => {
  await apolloClientPrivate.mutate<
    RemoveElementMutation,
    RemoveElementMutationVariables
  >({
    mutation: RemoveElementDocument,
    variables: {
      topicId: topic.id,
      elementId: element.id
    }
  })
}

export default {
  canMoveUp,
  canMoveDown,
  onDragUp,
  onDragDown,
  onMoveUp,
  onMoveDown,
  onRemove
}
